export default "__VITE_ASSET__082a0988__"